const getBookingJourneysURL = (bookingReference, membershipNumber, subscriptionID, subscriptionCode) =>
  `/manage/bookings/${bookingReference}/journeys${
    membershipNumber
      ? `?membershipNumber=${membershipNumber}${
          subscriptionID ? `&subscriptionID=${subscriptionID}&subscriptionCode=${subscriptionCode}` : ''
        }`
      : ''
  }`;

const getBookingExtrasURL = (bookingReference, membershipNumber) =>
  `/manage/bookings/${bookingReference}/extras${membershipNumber ? `?membershipNumber=${membershipNumber}` : ''}`;

const getExchangePaymentURL = (bookingReference, currency, membershipNumber, isMissedDeparture, isFlowForwardCapped) => {
  let queryString = new URLSearchParams({
    ...(currency && { currency }),
    ...(membershipNumber && { membershipNumber }),
    ...(isMissedDeparture && { isMissedDeparture }),
    ...(isFlowForwardCapped && { isFlowForwardCapped })
  }).toString();
  if (queryString) {
    queryString = `?${queryString}`;
  }

  return `/exchange/${bookingReference}/payment${queryString}`;
};

const getPendingPaymentURL = (bookingReference, currency, membershipNumber) => {
  let queryString = new URLSearchParams({
    ...(currency && { currency }),
    ...(membershipNumber && { membershipNumber })
  }).toString();
  if (queryString) {
    queryString = `?${queryString}`;
  }

  return `/manage/bookings/${bookingReference}/payment${queryString}`;
};

const getRefundMethodsURL = (
  bookingReference,
  currency,
  membershipNumber,
  isRefundingFeeOrInsurance = false,
  isRefundingThalysPass = false
) => {
  let queryString = new URLSearchParams({
    ...(currency && { currency }),
    ...(membershipNumber && { membershipNumber }),
    ...(isRefundingFeeOrInsurance && { isRefundingFeeOrInsurance }),
    ...(isRefundingThalysPass && { isRefundingThalysPass })
  }).toString();
  if (queryString) {
    queryString = `?${queryString}`;
  }

  return `/manage/bookings/${bookingReference}/refund-methods${queryString}`;
};

const getPaymentsURL = (bookingReference, membershipNumber) =>
  `/manage/bookings/${bookingReference}/payments${membershipNumber ? `?membershipNumber=${membershipNumber}` : ''}`;

const getBookingPaymentURL = (bookingReference, membershipNumber) =>
  `/booking/${bookingReference}/payment${membershipNumber ? `?membershipNumber=${membershipNumber}` : ''}`;

const getBookingSearchURL = (membershipNumber, subscriptionID, subscriptionCode) =>
  `/search${
    membershipNumber
      ? `?membershipNumber=${membershipNumber}${
          subscriptionID ? `&subscriptionID=${subscriptionID}&subscriptionCode=${subscriptionCode}` : ''
        }`
      : ''
  }`;

const getHomeUrl = () => '/';

const getRefundsURL = (bookingReference, membershipNumber) =>
  `/manage/bookings/${bookingReference}/refunds${membershipNumber ? `?membershipNumber=${membershipNumber}` : ''}`;

const getBookingAssistanceURL = (bookingReference, membershipNumber) =>
  `/booking/${bookingReference}/assistance/add${membershipNumber ? `?membershipNumber=${membershipNumber}` : ''}`;

const getBookingTravelDocumentsURL = (bookingReference, membershipNumber) =>
  `/booking/${bookingReference}/travel-documents${membershipNumber ? `?membershipNumber=${membershipNumber}` : ''}`;

const getClubEurostarSubscriptionURL = (membershipNumber, bookingReference) =>
  `/clubeurostar/${membershipNumber}${bookingReference ? `?reference=${bookingReference}` : ''}#subscriptions`;

const getLiveTrainsURL = (origin, destination, startDate, trainNumber) =>
  `/live-trains?${new URLSearchParams({ destination, origin, startDate, trainNumber }).toString()}`;

export {
  getBookingExtrasURL,
  getBookingJourneysURL,
  getRefundsURL,
  getPaymentsURL,
  getRefundMethodsURL,
  getExchangePaymentURL,
  getPendingPaymentURL,
  getBookingPaymentURL,
  getBookingSearchURL,
  getBookingAssistanceURL,
  getHomeUrl,
  getClubEurostarSubscriptionURL,
  getBookingTravelDocumentsURL,
  getLiveTrainsURL
};
